module.exports = __webpack_public_path__ + "img/default-avatar.01695500.png";